import React from 'react';
import { Typography } from '@mui/material';
import { HormoneSnapshot, ResultType } from '../../../types';
import { useMe } from '../../../config/api/queries';
import { Loading } from '../../Layout';

export const Header = ({
  hormoneSnapshots,
}: {
  hormoneSnapshots: HormoneSnapshot[];
}): JSX.Element => {
  const me = useMe();

  if (me.isLoading) {
    return <Loading />;
  }

  if (me.isError) {
    console.error('Error fetching user');
    return <></>;
  }

  const resultOrder = [
    ResultType.Normal,
    ResultType.Alarmed,
    ResultType.Imbalanced,
    ResultType.Exhausted,
  ];

  let message = '';

  if (hormoneSnapshots && hormoneSnapshots.length > 0) {
    if (hormoneSnapshots.length === 1) {
      message = 'Your results are in.';
    } else {
      const [latestSnapshot, previousSnapshot] = hormoneSnapshots;
      const latestIndex = resultOrder.indexOf(
        latestSnapshot.result as ResultType
      );
      const previousIndex = resultOrder.indexOf(
        previousSnapshot.result as ResultType
      );

      if (latestIndex === previousIndex) {
        message = 'Keep up the good work.';
      } else if (latestIndex < previousIndex) {
        message = "Congrats, you've improved!";
      } else {
        message = "You haven't improved.";
      }
    }
  }

  return (
    <>
      <Typography variant="medium" fontSize={24} sx={{ mb: 1, mt: 4 }}>
        Welcome back, {me.data?.first_name}
      </Typography>
      <Typography variant="light">{message}</Typography>
    </>
  );
};
